import { ThemeProps } from '../props/theme/theme-props';
import { ThemeStore } from '../store/theme-store';
import { ThemeMutationAPI } from '../api/theme-mutation-api';
import { DataModel } from './data-model';
import type { IEventManager } from '../manager/event-manager';
import type { IThemeData } from '../data';
import type { IThemeProps } from '../props/theme/theme-props';
import type { RestrictedDataModel } from './data-model';
import type { PresentationDataModel } from './presentation-data-model';
import type { IBaseContext } from '../context/base-context';

export class ThemeDataModel extends DataModel<IThemeData> {
    public store: ThemeStore;
    public props: IThemeData;
    public api: ThemeMutationAPI;
    public context: IBaseContext = {
        getPresentation: () => {
            return this.parent;
        },
        getTarget: () => this,
    };

    public constructor(data: IThemeData, events: IEventManager, public parent: PresentationDataModel) {
        super(events);

        this.store = new ThemeStore(data, events, this);
        this.props = new ThemeProps(this.store.data);
        this.api = new ThemeMutationAPI(this, events);
    }
}

export { IThemeProps };
export type IThemeDataModel = RestrictedDataModel<ThemeDataModel>;
